import { LEGACY_DRAFT_STORAGE_KEYS } from "./constants";

export const purgeLegacyVoucherDrafts = (): void => {
  try {
    LEGACY_DRAFT_STORAGE_KEYS.forEach((key: string): void =>
      localStorage.removeItem(key),
    );
  } catch {
    return;
  }
};
